var gumshoe = require('../vendors/gumshoe');

if (document.querySelector('.scrollspy-navbar')) {
    let navbarContainer = document.querySelectorAll('.scrollspy-navbar')[0];

    // Find all sections to add to scrollspy nav list
    const jumpSections = Array.prototype.slice.call(document.querySelectorAll('[data-scrollspy="true"]'));
    let jumpList = '';

    // Create list item by looping through each section
    jumpSections.forEach(section => {
        let sectionTitle = section.getAttribute('data-scrollspy-title');
        let sectionTarget = section.id;

        jumpList += `<li><a class="campaign-nav-link" href="#${sectionTarget}">${sectionTitle}</a></li>`;
    });

    // Add string of list items to scrollspy nav
    const jumpListContainer = navbarContainer.querySelectorAll('nav ul')[0];
    jumpListContainer.innerHTML = jumpList;

    // Handler when the DOM is fully loaded
    document.addEventListener('DOMContentLoaded', function() {
        gumshoe.init({
            selector: '[data-gumshoe] a', // Default link selector (must use a valid CSS selector)
            selectorHeader: '#siteHeader', // Fixed header selector (must use a valid CSS selector)
            container: window, // The element to spy on scrolling in (must be a valid DOM Node)
        });
    });

    let linkList = Array.prototype.slice.call(document.querySelectorAll('.campaign-nav-link'));

    linkList.forEach(link => {
        link.addEventListener('click', function (e) {
            e.preventDefault();
            let linkHref = link.getAttribute('href').replace('#', '');
            let linkBlock = document.getElementById(linkHref);
            let siteHeader = document.querySelector('.header-top');
            let siteHeaderHeight = siteHeader.clientHeight;
            let lastPosition = window.pageYOffset;

            if (window.innerWidth <= 960) {
                let closeModalBtn = document.querySelector('.mobile-nav-trigger-js') as HTMLButtonElement;
                closeModalBtn.click();

                window.scroll({
                    top: linkBlock.offsetTop - siteHeaderHeight - 10
                })
            }
            else {
                siteHeader.parentElement.classList.add('campaign-header-show');
                siteHeader.parentElement.setAttribute('data-automated-scroll', 'true');

                function scrollPosition() {
                    let linkBlockPosition = linkBlock.offsetTop - siteHeaderHeight - 10;

                    if (linkBlockPosition == window.pageYOffset || linkBlockPosition < window.pageYOffset || window.pageYOffset < lastPosition) {
                        setTimeout(function () {
                            siteHeader.parentElement.setAttribute('data-automated-scroll', 'false');
                        }, 5)
                        lastPosition = window.pageYOffset;
                        window.removeEventListener('scroll', scrollPosition);
                    }
                    else {
                        lastPosition = window.pageYOffset;
                    }
                }

                window.addEventListener('scroll', scrollPosition);

                window.scroll({
                    top: linkBlock.offsetTop - siteHeaderHeight - 10,
                    behavior: 'smooth'
                })
            }
        })
    })
}
